import dynamic from "next/dynamic";
import { ReactNode } from "react";

// Dynamically import SwitchTransition only on client side to avoid build issues
// Using 'as any' to avoid type checking during build
const SwitchTransition = dynamic(
  () =>
    import("react-transition-group").then((mod) => mod.SwitchTransition) as any,
  { ssr: false }
) as any;

type ClientSwitchTransitionProps = {
  children: ReactNode;
  mode?: "out-in" | "in-out";
  [key: string]: any; // Allow any other props
};

const ClientSwitchTransition = ({
  children,
  ...props
}: ClientSwitchTransitionProps) => {
  // During SSR, render children without transition
  if (typeof window === "undefined") {
    return <>{children}</>;
  }

  return <SwitchTransition {...props}>{children}</SwitchTransition>;
};

export default ClientSwitchTransition;
